import { Parser } from '~/api';
import RequestService from './request';

interface StartupSaveData {
    environment?: Record<string, string>;
}

interface DockerImageUpdateData {
    image: string;
}

class StartupService {
    getAll(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/servers/:server/startup', req).then(Parser.parse);
    }

    async save(data: StartupSaveData): Promise<ListResponse> {
        return RequestService.put('/servers/:server/startup', data).then(Parser.parse);
    }

    async updateImage(data: DockerImageUpdateData): Promise<void> {
        return RequestService.put('/servers/:server/startup/image', data);
    }
}

export default new StartupService();
